import createCachedSelector from 're-reselect'

import { selectIsPreviousPeriodAvailable } from 'ducks/reports/controls'

import gaugeCacheKey from './cacheKeys/gaugeCacheKey'
import selectDecoratedGauge from './selectDecoratedGauge'
import selectDecoratedJoinedThroughGauge from './selectDecoratedJoinedThroughGauge'

export default createCachedSelector(
  selectDecoratedJoinedThroughGauge,
  state => state,
  (state, props) => props,
  (state, { includePrevious }) =>
    !!includePrevious && selectIsPreviousPeriodAvailable(state),
  (decoratedJoinedThroughGauge, state, props, includePrevious) => {
    const { gauges, sort: { by: sortBy } = {} } = props
    function isSortedGauge({ id }) {
      return (
        id &&
        sortBy &&
        sortBy.match(
          new RegExp(`^${id.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')}(-|$)`)
        )
      )
    }
    // We need to decorate the sorted gauge first so that the other gauges
    // can derive whether they can be loaded or not.
    const sortedGauge = gauges.find(isSortedGauge)
    if (!sortedGauge) return null
    // eslint-disable-next-line no-use-before-define
    return selectDecoratedGauge(state, {
      ...props,
      includePrevious,
      decoratedJoinedThroughGauge,
      gauge: sortedGauge,
      skipSortedGauge: true,
    })
  }
)(gaugeCacheKey)
